export function percentOf(part: number, whole: number): number {
  if (!whole) return 0;
  return (part / whole) * 100;
}

export function formatPercent(value: number): string {
  return `${value.toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 0 })}%`;
}

export function formatCount(value: number | undefined): string {
  return (value ?? 0).toLocaleString("en-US");
}
